import React from 'react';
import { useTheme } from 'styled-components';
import { ChatUIEnhancementCategoryCard } from 'Assistant/__generated__/client.schemas';
import { getCategoryIcon } from 'Explore/categoryIcons';
import { multiDestinationLogger } from 'App/Tracking/multiDestinationLogger';
import DynamicIcon from 'Shared/DynamicIcon/DynamicIcon';
import { extractSlugNameFromPath } from 'Assistant/Chatbot/utils';
import RoutePath from 'App/RoutePath';
import { Pill, IconWrap, Label } from './styles';

type CategoryPillProps = {
  value: ChatUIEnhancementCategoryCard;
  className?: string;
};

const CategoryPill = ({ value, className }: CategoryPillProps) => {
  const title = value.title;
  const slug = extractSlugNameFromPath(value.slug);
  const theme = useTheme();
  if (!slug) return null;

  const Icon = getCategoryIcon(slug);

  const trackCategoryCardClicked = () => {
    void multiDestinationLogger({
      eventName: 'content-selected',
      properties: {
        contentSlug: slug,
        source: 'assistant-category-card-pill',
        contentCategoryPath: `${slug}`,
      },
    });
  };

  return (
    <Pill
      to={{
        pathname: `${RoutePath.Explore}/${slug}`,
        state: {
          from: location.pathname,
          referrer: 'coach/chat',
        },
      }}
      replace={false}
      className={className}
      data-testid="assistant-category-card-pill"
      aria-label={`Category: ${title}`}
      onClick={trackCategoryCardClicked}
    >
      <IconWrap aria-hidden="true">
        <DynamicIcon
          Icon={Icon}
          height={18}
          width={18}
          primaryColor={theme.colors.text.primary}
        />
      </IconWrap>
      <Label>{title}</Label>
    </Pill>
  );
};

export default CategoryPill;
